import React, { createContext, useContext, useState } from "react";

// Create a Cache Context
const CacheContext = createContext();

// Create a provider component
export function CacheContextProvider({ children }) {
  const [cacheItems, setCacheItems] = useState({}); // Initialize cache as an object
  const [pageLoader, setPageLoader] = useState(false);
  return (
    <CacheContext.Provider value={{ cacheItems, pageLoader, setCacheItems, setPageLoader }}>
      {children}
    </CacheContext.Provider>
  );
}

// Custom hook to use the Cache Context
export const useCache = () => {
  return useContext(CacheContext);
};
